import {autoinject, bindable} from 'aurelia-framework';
import {UrlState} from "../services/url-state";

@autoinject()
export class ActiveOnAnchorCustomAttribute {

  @bindable({ primaryProperty: true }) tag: string;
  hashChanged: any;
  initial: boolean = true;

  constructor(private element: Element,
              private urlState: UrlState) {}


  bind() {
    this.urlState.registerListener(this);
  }

  hashStateChanged(newValue) {
    if(newValue == this.tag) {
      this.element.classList.add('active');
    }else {
      this.element.classList.remove('active');
    }
  }
}
